/**
 * author andre.pitombeira
 */
export default function RedemptionEditController($scope, $timeout, $stateParams, RedemptionService, OPTIONS, NotificationService) {
  var redemptionEdit = this;

  redemptionEdit.selectedRedemption = {};
  redemptionEdit.redemptionId = parseInt($stateParams.redemptionId, 10);
  redemptionEdit.options = {};
  redemptionEdit.isLoading = false;
  redemptionEdit.isUpdateRedemptionBtnDisabled = false;
  redemptionEdit.options.statuses = OPTIONS.statuses.redemptions;

  redemptionEdit.init = function() {
    redemptionEdit.retrieveRedemption();
  };

  redemptionEdit.retrieveRedemption = function() {
    if (!redemptionEdit.redemptionId || redemptionEdit.isLoading) {
      return;
    }

    redemptionEdit.isLoading = true;

    RedemptionService.retrieveRedemption(redemptionEdit.redemptionId)
      .then(function(res) {
        redemptionEdit.selectedRedemption = res.data ? res.data : redemptionEdit.selectedRedemption;
        redemptionEdit.selectedStatus = redemptionEdit.selectedRedemption.status;
      })
      .finally(function() {
        redemptionEdit.isLoading = false;
      });
  };

  redemptionEdit.updateStatus = function() {
    var params = {};

    if (redemptionEdit.selectedStatus === redemptionEdit.selectedRedemption.status || redemptionEdit.isLoading) {
      return;
    }

    params.status = redemptionEdit.selectedStatus;

    RedemptionService.updateRedemption(redemptionEdit.selectedRedemption.id, params).then(function() {
      redemptionEdit.selectedRedemption.status = redemptionEdit.selectedStatus;
      NotificationService.success('The redemption was successfully updated.');
      $scope.$emit('redemption-edit-controller.refresh-redemption-list');
    });
  };

  redemptionEdit.checkUpdateRedemptionBtn = function() {
    if (redemptionEdit.selectedRedemption.status === 'REDEEMED') {
      redemptionEdit.isUpdateRedemptionBtnDisabled = true;
    } else {
      redemptionEdit.isUpdateRedemptionBtnDisabled = false;
    }
  };

  $scope.$watch('redemptionEdit.selectedStatus', function() {
    redemptionEdit.checkUpdateRedemptionBtn();
  });

  redemptionEdit.init();
}



// WEBPACK FOOTER //
// ./src/app/redemptions/redemption.edit.controller.js